import React from 'react';
import jsonwebtoken from 'jsonwebtoken';

export const useJwt = () => {
  const getJwtPayload = React.useCallback(token => {
    const decodedJwt = jsonwebtoken.decode(token, {
      complete: true,
    });
    return decodedJwt.payload || {};
  }, []);

  return { getJwtPayload };
};

export default useJwt;
